import { TextInput } from '../FormsyHelperComponent'
import { Paper } from '@material-ui/core'
import ErrorBoundary from 'app/components/ErrorBoundary'
import apiConfigs from 'app/configs/apiConfigs'
import { RegisterSuggestionList } from 'app/componentV4/RegisterSuggestionList'
import clsx from 'clsx'
import { withFormsy } from 'formsy-react'
import PropTypes from 'prop-types'
import * as R from 'ramda'
import React, { useEffect, useState } from 'react'
import { FormattedMessage } from 'react-intl'
import Script from 'react-load-script'
import PlacesAutocomplete, {
  geocodeByPlaceId,
  getLatLng,
} from 'react-places-autocomplete'
import tzlookup from 'tz-lookup'

const BasePlacesAutocompleteFormsy = ({
  // classes,
  value,
  setValue,
  onSelectPlaceSuggestion = () => {},
  onSelectNothing,
  handleClearLocation,
  // defaultCountry,
  inputProps = {},
  InputProps,
  errorMessage,
  labelId,
  parseValue,
  placeholderId,
  required,
  clearBtn,
  variant = false,
  // selectSuggestion = false,
  clickedSuggestion = false,
  isShowMaxLength = true,
  restriction = false,
  isMapLoaded = null,
  ...props
}) => {
  const [isLoadingExternalScript, setIsLoadingExternalScript] = useState(
    isMapLoaded === null ? true : !isMapLoaded,
  )
  useEffect(() => {
    if (isMapLoaded !== null) {
      setIsLoadingExternalScript(!isMapLoaded)
    }
  }, [isMapLoaded])
  const handleSelectPlaceSuggestion = (name) => async () => {
    const result = R.head(await geocodeByPlaceId(R.prop('placeId', name)))
    setValue(parseValue(R.mergeRight(name, result)))
    const latLng = await getLatLng(result)
    const timeZoneId = tzlookup(R.prop('lat', latLng), R.prop('lng', latLng))

    onSelectPlaceSuggestion({
      suggestion: name,
      ...result,
      ...latLng,
      timeZoneId,
    })
  }

  const onTextClear = () => {
    setValue('')
    R.unless(R.isNil, R.call, onSelectNothing)
  }

  const searchOptions = {}
  if (restriction) {
    searchOptions.types = ['address']
    searchOptions.componentRestrictions = { country: restriction }
  }

  const handleChange = R.compose(
    () => R.unless(R.isNil, R.call, handleClearLocation),
    () => R.unless(R.isNil, R.call, onSelectNothing),
    (e) => {
      setValue(e)
      R.unless(R.isNil, (f) => f(e), props.getAutoPlaceFormsyData)
    },
  )

  return (
    <ErrorBoundary
      fallback={
        <div className="flex flex-col p-8 rounded shadow-lg">
          <span className="font-bold">
            <FormattedMessage id="error.general" />
          </span>
        </div>
      }
    >
      {isMapLoaded === null && (
        <Script
          url={`https://maps.googleapis.com/maps/api/js?key=${apiConfigs.googleAPI}&libraries=places`}
          onCreate={() => setIsLoadingExternalScript(true)}
          onLoad={() => setIsLoadingExternalScript(false)}
          onError={() => setIsLoadingExternalScript(false)}
        />
      )}
      {!isLoadingExternalScript && (
        <div>
          <PlacesAutocomplete
            value={value}
            onChange={handleChange}
            onError={() => {}}
            searchOptions={searchOptions}
          >
            {/* to do arg. loading  */}
            {({ getInputProps, suggestions, getSuggestionItemProps }) => {
              const properties = {
                containerClassName: clsx(
                  'w-full relative',
                  inputProps.className,
                ),
                name: 'placeAutoCompleteFormsy',
                required: required,
                labelId: labelId,
                placeholderId: placeholderId,
                variant: variant || 'outlined',
                onTextClear: onTextClear,
                clearBtn: clearBtn,
              }

              if (isShowMaxLength) {
                properties['maxLength'] = 199
              }
              return (
                <div className="relative">
                  <TextInput
                    {...getInputProps()}
                    {...properties}
                    inputProps={inputProps}
                    InputProps={InputProps}
                  />
                  <div className="relative">
                    <Paper
                      className="absolute b-0 l-0 w-full"
                      style={{ zIndex: 3 }}
                    >
                      <RegisterSuggestionList
                        suggestions={suggestions}
                        getSuggestionItemProps={getSuggestionItemProps}
                        onSelectPlaceSuggestion={handleSelectPlaceSuggestion}
                        clickedSuggestion={clickedSuggestion}
                      />
                    </Paper>
                  </div>
                </div>
              )
            }}
          </PlacesAutocomplete>
          {errorMessage && (
            <label className="mt-8 block text-red">{errorMessage}</label>
          )}
        </div>
      )}
    </ErrorBoundary>
  )
}

BasePlacesAutocompleteFormsy.propTypes = {
  onSelectPlaceSuggestion: PropTypes.func,
  labelId: PropTypes.string.isRequired,
  placeholderId: PropTypes.string.isRequired,
  inputProps: PropTypes.object,
  InputProps: PropTypes.object,
  parseValue: PropTypes.func.isRequired,
}
export default React.memo(withFormsy(BasePlacesAutocompleteFormsy))
